import { OptInFeaturesList } from './Components/OptInFeaturesList/OptInFeaturesList';

export const OptInFeatures = () => <OptInFeaturesList />;
